<template>
    <div>
        <span
            class="btn-position"
            @click="handlerGoMap('1')"
        ></span>
        <span
            class="btn-360"
            @click="handlerGoMap('2')"
        ></span>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { getPanoramaAddress } from '@/api/map'
/**
 * @description 地图 360全景
 */
export default {
    props: {
        currentResource: {
            type: Object,
            default: () => {}
        }
    },
    watch: {
        currentResource: {
            handler(val) {
                // console.log(val);
                this.resoureItem = val
            },
            immediate: true
        }
    },
    computed: {
        ...mapGetters(['activeParkId'])
    },
    data() {
        return {
            resoureItem: null
        }
    },
    mounted() {
        // console.log(this.currentResource)
    },
    methods: {
        handlerGoMap(type) {
            if (type === '1') {
                const href = this.$router.resolve({
                    name: 'MapIndex',
                    query: {
                        id: this.activeParkId,
                        name: this.currentResource.title
                    }
                }).href
                window.open(href, '_blank')
            } else {
                // 360
              // console.log('360')
              let params = {
                parkId: this.activeParkId,
                name: this.currentResource.title
              }
              getPanoramaAddress(params).then(res => {
                console.log(res.data)
                if(res.data === null){
                  this.$alert('该景点全景数据正在建设中，敬请期待！', '', {
                    showClose: false,
                    center: true,
                    roundButton: true,
                    confirmButtonClass: 'custom-alter-btn',
                    customClass: 'custom-alter-360',
                    callback: action => {
                      console.log(action);
                    }
                  });
                } else {
                  window.open(res.data, '_blank')
                }
              })
            }
        }
    }
}
</script>
<style lang="scss">
.btn-position {
    display: inline-block;
    width: 30px;
    height: 30px;
    border-radius: 50px;
    background-color: #208060;
    margin-right: 12px;
    cursor: pointer;
    position: relative;
    &::before {
        position: absolute;
        display: inline-block;
        content: "";
        width: 18px;
        height: 18px;
        background: url("@/assets/commonImg/icon-position@2x.png") no-repeat
            center;
        background-size: 100% 100%;
        left: 50%;
        top: 50%;
        margin-left: -9px;
        margin-top: -10px;
    }
}
.btn-360 {
    display: inline-block;
    width: 30px;
    height: 30px;
    border-radius: 50px;
    background: #208060;
    cursor: pointer;
    position: relative;
    &::before {
        position: absolute;
        display: inline-block;
        content: "";
        width: 27px;
        height: 36px;
        background: url("@/assets/commonImg/icon-position-360.png") no-repeat
            center;
        background-size: 100% 100%;
        left: 50%;
        top: 50%;
        margin-left: -13px;
        margin-top: -18px;
    }
}
@media screen and (min-width: 1920px) {
    .btn-position {
        width: 40px !important;
        height: 40px !important;
        margin-right: 16px !important;
        &::before {
            width: 24px !important;
            height: 24px !important;
            margin-left: -12px;
            margin-top: -12px;
        }
    }
    .btn-360 {
        width: 40px !important;
        height: 40px !important;
        &::before {
            width: 36px !important;
            height: 49px !important;
            margin-left: -17px !important;
            margin-top: -24px !important;
        }
    }
}
</style>